import task from '@nextories/vue-tasks/src/i18n/langs/fr/task';

export default {
  ...task,
  select: {
    ...task.select,
    status: [
      {
        name: 'À traiter',
        value: 'Not Started',
      },
      {
        name: 'Décalé',
        value: 'Deferred',
      },
      {
        name: 'Clôturé',
        value: 'Completed',
      },
    ],
  },
};
